enum Routes {
    HOME = '/',
    LOGIN = '/login',
}
export default Routes;